import { render, staticRenderFns } from "./StatSecondaryCard.vue?vue&type=template&id=2c4c4955&scoped=true&"
import script from "./StatSecondaryCard.vue?vue&type=script&lang=js&"
export * from "./StatSecondaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4c4955",
  null
  
)

export default component.exports